import React from 'react';
import PropTypes from 'prop-types';

const RugbyPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M27.072 5.617a4.497 4.497 0 0 0-.72-.984C23.552 1.757 14.467 2.468 8.47 8.465 2.477 14.46 1.746 23.664 4.642 26.344c.282.261.613.494.98.694 1.86 1.021 4.727 1.25 7.81.543 3.076-.706 6.369-2.344 9.093-5.069a19.073 19.073 0 0 0 4.955-8.68c.834-3.256.642-6.311-.408-8.215zM5.169 23.958c-1.38-3.17.02-9.656 4.583-14.219 4.58-4.58 11.021-6.311 14.301-4.546-2.173.261-4.86 1.446-7.598 3.365-1.184-.526-3.59.47-5.465 2.325-1.785 1.764-2.439 3.876-2.05 5.008-2.153 2.896-3.485 5.771-3.77 8.067zm5.747-10.968c1.352-1.768 2.602-3.018 4.163-3.333 1.72.364-2.03 2.292-3.75 4.996-.36.576-1.765.106-.413-1.663zm-4.37 12.447c-.593-2.002.772-5.302 3.378-8.73 1.184.184 3.223-.653 4.873-2.283 1.585-1.568 2.435-3.541 2.345-4.763 3.149-2.25 6.253-3.52 8.292-3.124.65 2.765-2.108 7.777-6.614 12.278-4.256 4.257-9.33 7.116-12.274 6.622zm17.425-7.684a18.448 18.448 0 0 1-2.728 3.485 18.128 18.128 0 0 1-4.077 3.043c-2.549 1.4-5.24 2.095-7.438 2.07 3.035-.943 6.687-3.267 10.024-6.604 3.345-3.346 5.67-7.006 6.609-10.049.078 2.37-.723 5.306-2.39 8.055z"
    />
  );
};

RugbyPath.propTypes = {
  fill: PropTypes.string,
};

export default RugbyPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/rugby.jsx